import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";

const LABEL = { admin: "Administrador", cliente: "Cliente" };

export const UsersTab = () => {
  const call = useApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = useCallback(() => call("get", "/users").then((r) => setData(r.data)), [call]);
  useEffect(() => { load(); }, [load]);

  const change = async (id, role) => {
    try { await call("patch", `/users/${id}/role`, { role }); toast.success("Rol actualizado"); }
    catch (e) { toast.error(errMsg(e)); }
    load();
  };

  return (
    <div className="bg-white border divide-y" data-testid="admin-users-tab">
      {data.users.map((u) => (
        <div key={u.user_id} className="p-4 flex items-center gap-4 text-sm" data-testid={`admin-user-${u.user_id}`}>
          <div className="flex-1"><p className="font-semibold">{u.name || "Sin nombre"}</p><p className="text-xs text-slate-500">{u.email}</p></div>
          <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} className="h-9 border rounded-full px-3" data-testid={`admin-user-role-${u.user_id}`}>
            {data.roles.map((r) => <option key={r} value={r}>{LABEL[r] || r}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
};
